// src/frontend/data/books/DarkForest/data/cap12.js

const CAP12 = {
  id: 12,
  title: "Billetera fría (Cold Wallet)",
  sections: [
    {
      heading: "¿Qué es realmente una Cold Wallet?",
      text: [
        "Una cold wallet es cualquier billetera que mantiene sus claves privadas completamente fuera de línea. Mientras no exista conexión a Internet, se considera un entorno frío y, por lo tanto, mucho más seguro ante ataques remotos.",
        "Desde la perspectiva de seguridad, una cold wallet no está diseñada para ser cómoda, sino para reducir al mínimo la exposición al riesgo.",
        "Aun así, existe un desafío evidente: ¿cómo utilizarla si está desconectada? Aquí es donde entran en juego los mecanismos de transmisión y las aplicaciones auxiliares."
      ]
    },
    {
      heading: "¿Cómo usar una Cold Wallet para recibir fondos?",
      text: [
        "Recibir criptomonedas es la parte más sencilla. No se necesita conexión a Internet ni proceso firmado.",
        "Basta con generar y mostrar la dirección pública desde la cold wallet.",
        "Para facilitar el rastreo del saldo, se utiliza una ‘watch-only wallet’ (imToken, OneKey, Trust Wallet con modo de solo lectura), donde simplemente agregas tu dirección pública.",
        "Estas aplicaciones permiten visualizar movimientos sin arriesgar la clave privada."
      ]
    },
    {
      heading: "¿Cómo enviar criptomonedas desde una Cold Wallet?",
      text: "Existen tres métodos principales para transmitir datos entre la cold wallet y la aplicación online (Light App):",
      list: [
        "Código QR",
        "USB",
        "Bluetooth"
      ]
    },
    {
      heading: "¿Cómo funciona el proceso interno (principio esencial)?",
      text: [
        "Todas las variantes siguen el mismo principio fundamental: firmar datos del lado offline y transmitirlos al lado online para su difusión en la blockchain.",
        "El proceso estándar es:",
        "1. La Light App (en línea) genera la transacción que debe firmarse y la envía a la cold wallet por QR/USB/Bluetooth.",
        "2. La cold wallet firma la transacción usando la clave privada.",
        "3. La cold wallet devuelve la firma a la Light App usando el mismo medio.",
        "4. La Light App publica (broadcast) la transacción firmada en la blockchain.",
        "Aunque parezca un proceso largo, con práctica se vuelve rutinario y brinda una sensación de seguridad superior."
      ]
    },
    {
      heading: "Limitaciones técnicas en cada método",
      subsections: [
        {
          heading: "QR Code",
          text: [
            "Los códigos QR tienen capacidad limitada, por lo que una transacción compleja puede requerir dividir los datos en múltiples QR.",
            "Es uno de los métodos más seguros, ya que no implica cables ni conexiones inalámbricas continuas."
          ]
        },
        {
          heading: "USB",
          text: [
            "Es más rápido y puede transferir mayor cantidad de datos.",
            "Requiere confiar en que el entorno USB no esté comprometido."
          ]
        },
        {
          heading: "Bluetooth",
          text: [
            "Ofrece la mejor experiencia de usuario, pero introduce más superficie de ataque.",
            "Debe utilizarse en wallets con protocolos Bluetooth auditados."
          ]
        }
      ]
    },
    {
      heading: "Riesgos comunes al usar una Cold Wallet",
      text: [
        "Aunque una cold wallet reduce riesgos remotos, no elimina los riesgos humanos. Estos son algunos de los ataques más frecuentes:"
      ],
      subsections: [
        {
          heading: " Enviar monedas a la dirección equivocada",
          text: [
            "Muchos usuarios solo revisan los primeros y últimos caracteres de la dirección destino.",
            "Atacantes pueden generar direcciones que coinciden parcialmente y reemplazar tu dirección objetivo mediante malware en la Light App.",
            "Resultado: transfieres fondos a la dirección del atacante creyendo que era la correcta."
          ]
        },
        {
          heading: " Autorizar tokens a direcciones maliciosas",
          text: [
            "En Ethereum y EVM, el mecanismo 'approve' permite que un contrato tenga permiso para gastar tus tokens.",
            "Muchos usuarios aprueban cantidades ilimitadas sin entenderlo.",
            "Una dirección maliciosa con esa aprobación puede vaciar todos los tokens autorizados.",
            "Este tipo de robo ocurre incluso sin que el usuario firme un ‘send’ explícito."
          ]
        },
        {
          heading: " Firmar transacciones aparentemente inocentes",
          text: [
            "Algunas firmas ocultan llamadas complejas dentro de datos codificados.",
            "Lo que parece un mensaje trivial puede ejecutar acciones peligrosas.",
            "Estos riesgos se explicarán en detalle en capítulos posteriores."
          ]
        },
        {
          heading: " Información insuficiente en la pantalla de la cold wallet",
          text: [
            "Si la cold wallet no muestra datos completos (monto, token, dirección exacta, contrato), el usuario puede confiarse y firmar algo que no comprende."
          ]
        }
      ]
    },
    {
      heading: "Las dos causas fundamentales de los errores",
      list: [
        "1. Falta del principio de seguridad ‘Lo que ves es lo que firmas’.",
        "2. Falta de conocimiento del usuario sobre los riesgos involucrados."
      ]
    },
    {
      heading: "Mensaje final",
      text: [
        "Las cold wallets son una herramienta poderosa, pero requieren atención, paciencia y hábito. La seguridad no depende solo del dispositivo, sino de cómo lo usa el usuario.",
        "Mientras más entiendas los riesgos y mejores tus prácticas, más cerca estarás de una experiencia cripto realmente segura."
      ]
    }
  ]
};

export default CAP12;
